<ng-container *ngIf="!hideHeader">
    <ms-grid-header
        class="margin-right"
        *ngIf="!showGridPillHeader; else gridPillHeader"
        [columns]="columns"
        [sport]="couponModel.sport"
        [sorting]="couponModel.sorting"
        [isSortingVisible]="!couponModel.disableGroupSorting"
        [hideTitle]="isTitleHide"
        [sortingTracking]="sortingTracking"
        [useColoredIcon]="useColoredIcon"
        [hideMarketSwitcher]="collapseSportHeaders ? !expandedSport[couponModel.sport.id] : hideMarketSwitcher"
        [isSportHeaderCollapsed]="collapseSportHeaders ? !expandedSport[couponModel.sport.id] : undefined"
        [eventsCount]="eventCount"
        [tracking]="tracking"
        [showRadioInputInSortSelector]="showRadioInputSortSelectorInHeader"
        [popperAppendTo]="popperAppendTo"
        [eventDetails]="betDetails"
        (groupChange)="groupChanged($event)"
        (moreChange)="moreToggled()"
        (sortingChange)="changeSorting($event)"
        (toggleAccordion)="accordionCollapsed($event)"
        (click)="collapseSportHeaders && toggleSportHeader(couponModel.sport)" />
</ng-container>

<div *ngIf="!collapseSportHeaders || (collapseSportHeaders && expandedSport[couponModel.sport.id])">
    <ms-performance-tracker [trigger]="couponModel.id" />

    <ms-event-group
        *ngFor="let eventGroup of couponModel.groups; trackBy: trackGroup"
        [msSwipeContainer]="swipeToggle"
        [columns]="columns"
        [group]="eventGroup"
        [grouping]="couponModel.grouping"
        [sportId]="couponModel.sport.id"
        [hideFavourites]="hideFavourites || hideHeaderRegion"
        [useColoredIcon]="useColoredIcon"
        [hideMarketHeader]="hideMarketHeader"
        [hideHeaderRegion]="hideHeaderRegion"
        (toggle)="groupToggled($event)">
        <ng-container *ngFor="let couponEvent of eventGroup.events; index as index; trackBy: trackEvent">
            <ms-coupon-event
                [ngClass]="couponGridClass"
                [msSwipeActions]="swipeTemplate"
                [swipeContext]="couponEvent"
                [couponEvent]="couponEvent"
                [couponGroups]="couponGroups"
                [linkConfig]="linkConfig"
                [media]="couponModel.media"
                [tracking]="trackingGameDetails(couponEvent, 'NonGridable', index)"
                [favouriteToggle]="favouriteToggle"
                [promotedFixtureIds]="promotedFixtureIdsMap"
                [msAutomation]="getAutomationAttributes(couponEvent)"
                [showParticipantImage]="showParticipantImage"
                [betDetails]="betDetails"
                [couponType]="couponType"
                [periodGroup]="periodGroup"
                (click)="eventClicked(couponEvent, index)"
                (statsClicked)="statsClicked.emit(couponEvent)"
                (moreBetsClicked)="moreBetsClicked.emit(couponEvent)" />
        </ng-container>
    </ms-event-group>
</div>
<ng-template #swipeTemplate let-couponEvent let-close="close">
    <ms-favourite-event-toggle [event]="couponEvent" [static]="true" (toggle)="close()" />
    <div class="swipe-message">
        <ng-container *ngIf="couponEvent.favourited; else favourites">{{ sitecore.favouritesMessages.RemoveFavourite }} </ng-container>
        <ng-template #favourites>{{ sitecore.favouritesMessages.AddFavourite }}</ng-template>
    </div>
</ng-template>

<ng-template #gridPillHeader>
    <ms-grid-pills-header
        [column]="columns[0]"
        [sport]="couponModel.sport"
        [hideTitle]="isTitleHide"
        [useColoredIcon]="useColoredIcon"
        [tracking]="tracking"
        [sorting]="couponModel.sorting"
        [sortingTracking]="sortingTracking"
        (pillChange)="groupChanged($event)"
        (sortingChange)="changeSorting($event)"
        (toggleAccordion)="accordionCollapsed($event)" />
</ng-template>
